import {
	getLinkedBusinessAccountList,
	mobileLogin as apiMobileLogin,
	sendEmail,
	signinEamilForMobile,
	signinEmail,
	signupEmail,
	verifyEmail,
	type sendEmailProps,
	type SigninEmailBody,
	type SignupEmailBody,
	type VerifyEmailBody,
} from '@/apis/auth';
import { refreshGeneralUserInfo } from '@/legacy/apis/repository/content';
import { putOwnerUser, saveBusinessDataToDexie } from '@/model/dexie/ownerDexie';
import { saveUserDataToDexie, tokenUpdate } from '@/model/dexie/userDexie';

// Re-export API functions
export { sendEmail, verifyEmail, signupEmail, signinEmail, signinEamilForMobile, getLinkedBusinessAccountList };
export type { sendEmailProps, VerifyEmailBody, SignupEmailBody, SigninEmailBody };

/** 갱신하고 조회된 비즈니스 계정 숫자 반환
 * 비즈니스 계정이 없으면 0.............
 */
export const LinkedBusinessRefresh = async () => {
	try {
		// 일반 유저 정보 갱신
		await refreshGeneralUserInfo();
	} catch (error) {
		console.error('[LinkedBusinessRefresh] refreshGeneralUserInfo 실패:', error);
		// 일반 유저 정보 갱신 실패해도 계속 진행
	}

	try {
		// 비즈니스 계정 목록 조회
		const { data: listData, error } = await getLinkedBusinessAccountList();

		if (error) {
			console.error('[LinkedBusinessRefresh] getLinkedBusinessAccountList 실패:', error);
			return 0;
		}

		// if (!listData || listData.data.linkedBusinessAccountList.length === 0) {
		// console.log('연결된 비즈니스 계정이 없습니다.')
		if (!listData?.data?.linkedBusinessAccountList) {
			console.log('[LinkedBusinessRefresh] 연결된 비즈니스 계정이 없습니다.');
			return 0;
		}

		const linkedList = (listData?.data?.linkedBusinessAccountList ?? []) as any[];

		if (linkedList.length > 0) {
			await saveBusinessDataToDexie(listData.data);
			console.log(`[LinkedBusinessRefresh] 비즈니스 계정 ${linkedList.length}개 저장 완료`);
		}
		return linkedList.length;
	} catch (error) {
		console.error('[LinkedBusinessRefresh] 비즈니스 계정 조회 중 에러:', error);
		return 0;
	}
};

export const mobileLogin = async (token: string) => {
	const result = await apiMobileLogin(token);
	if (result && result.data) {
		tokenUpdate(result.response);
		saveUserDataToDexie(result.data);
		putOwnerUser();
		return true;
	}
};
